import React from 'react';
import { HeaderWave as HeaderWaveStyled } from './HeaderWave.styles';

const HeaderWave = () => (
  <HeaderWaveStyled
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    viewBox="0 0 1440 63"
    version="1.1"
    preserveAspectRatio="none"
  >
    <path d="M1440,0 L1440,9 C1299.02889,39.8509165 1086.81005,56.9272796 840.991717,59.9636398 L730.152379,62.7940817 C691.442901,62.9313606 646.449901,63 595.17338,63 C518.258599,63 377.479724,53.7791366 273.162252,42.3975521 C168.84478,31.0159677 43.3122706,12.2596531 0,9 L0,0 L1440,0 Z" />
  </HeaderWaveStyled>
);

export default HeaderWave;
